import { Component } from "react";
import InputGroup from "./InputGroup";

type Props = {
  input?: $TSFixMe;
  label?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  cols?: number;
  rows?: number;
  handleBlur?: $TSFixMeFunction;
  handleChange?: $TSFixMeFunction;
  name?: string;
  isSubmitting?: boolean;
  values?: $TSFixMe;
  placeholder?: string;
};

class TextArea extends Component<Props> {
  inputField: $TSFixMe;

  componentDidMount() {
    if (this.props.autoFocus) {
      this.focus();
    }
  }

  focus() {
    setTimeout(() => {
      /* istanbul ignore next */
      if (this.inputField) {
        this.inputField.focus();
      }
    }, 50);
  }

  render() {
    const { input, disabled, cols, rows, placeholder } = this.props;
    let textarea;
    // REDUX FORM
    if (input) {
      textarea = (
        <textarea
          {...input}
          onChange={input.onChange}
          className="form-control"
          value={input.value}
          disabled={disabled}
          ref={(i) => {
            this.inputField = i;
          }}
          cols={cols || 50}
          rows={rows || 4}
          placeholder={placeholder}
        />
      );
      //  FORMIK
    } else {
      const { handleChange, handleBlur, name, values, isSubmitting } =
        this.props;
      const onChange = (e: $TSFixMe) => {
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        handleBlur(e);
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        handleChange(e);
      };
      textarea = (
        <textarea
          {...input}
          className="form-control"
          cols={cols || 50}
          disabled={disabled || isSubmitting}
          name={name}
          onChange={onChange}
          ref={
            /* istanbul ignore next */ (i) => {
              this.inputField = i;
            }
          }
          rows={rows || 4}
          // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
          value={values[name] || ""}
          maxLength={4000}
          placeholder={placeholder}
        />
      );
    }
    return <InputGroup {...this.props}>{textarea}</InputGroup>;
  }
}

export default TextArea;
